/**
 * Small wrappers around `localStorage` for per-browser preferences (layout, theme, filters,
 * node positions). Reading or writing may fail (private windows, blocked storage), so every
 * call is guarded and falls back to the default.
 */

/** Reads a JSON value saved under `key`, or returns `fallback`. */
export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

/** Saves `value` as JSON under `key`. Silently does nothing if storage is unavailable. */
export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage blocked or full: preferences simply are not kept.
  }
}

/** Removes `key`. */
export function forget(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Nothing to do.
  }
}
